<template>
  <div class="funcionalidades-panel">

    <div
      v-for="panel in paneles"
      :key="panel.key"
      class="acord-item"
      :class="{ 'is-open': abierto === panel.key }"
    >
      <!-- Header del acordeón -->
      <button
        type="button"
        class="acord-header"
        :class="{ 'is-open': abierto === panel.key }"
        @click="toggle(panel.key)"
      >
        <div class="acord-left">
          <span class="acord-icon material-symbols-outlined">{{ panel.icon }}</span>
          <div>
            <span class="acord-title">{{ panel.label }}</span>
            <span class="acord-sub">{{ panel.desc }}</span>
          </div>
        </div>
        <span class="material-symbols-outlined chevron">
          {{ abierto === panel.key ? 'expand_less' : 'expand_more' }}
        </span>
      </button>

      <!-- Contenido -->
      <div v-show="abierto === panel.key" class="acord-body">
        <component
          :is="panel.component"
          v-if="condicion && abierto === panel.key"
          :idPlanilla="idPlanilla"
          :idPrestador="idPrestador"
          :idUsuario="idUsuario"
          :fechaDesde="fechaDesde"
          :fechaHasta="fechaHasta"
          @cargado="$emit('cargado')"
          @anulado="$emit('anulado')"
        />
        <div v-else-if="!condicion" class="panel-bloqueado">
          <span class="material-symbols-outlined" style="font-size:22px">lock</span>
          No disponible en el estado actual del trámite
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import RegistroPorFechas     from "@/components/RegistroPorFechas.vue";
import RegistroVariosCodigos from "@/components/RegistroVariosCodigos.vue";
import RegistroDesdeCSV      from "@/components/RegistroDesdeCSV.vue";
import ConsultaPorCodigo     from "@/components/ConsultaPorCodigo.vue";
import InactivarCodigos      from "@/components/InactivarCodigos.vue";
import InsertarObservacion   from "@/components/InsertarObservacion.vue";

export default {
  name: "FuncionalidadesPanel",

  components: {
    RegistroPorFechas,
    RegistroVariosCodigos,
    RegistroDesdeCSV,
    ConsultaPorCodigo,
    InactivarCodigos,
    InsertarObservacion,
  },

  props: {
    idPlanilla:  { type: [Number, String], required: true },
    idPrestador: { type: [Number, String], required: true },
    idUsuario:   { type: [Number, String], required: true },
    fechaDesde:  { type: String, required: true },
    fechaHasta:  { type: String, required: true },
    condicion:   { type: Boolean, default: true },   // procesoAM && fechas válidas
  },

  emits: ["cargado", "anulado"],

  data() {
    return {
      abierto: null,
      paneles: [
        {
          key:       "fechas",
          label:     "Registro por fechas",
          desc:      "Registra códigos aplicando un rango de fechas",
          icon:      "date_range",
          component: "RegistroPorFechas",
        },
        {
          key:       "varios",
          label:     "Registro de varios códigos",
          desc:      "Ingresa múltiples códigos en una sola operación",
          icon:      "playlist_add",
          component: "RegistroVariosCodigos",
        },
        {
          key:       "csv",
          label:     "Registro desde CSV",
          desc:      "Carga masiva desde archivo .csv",
          icon:      "upload_file",
          component: "RegistroDesdeCSV",
        },
        {
          key:       "consulta",
          label:     "Consulta por código",
          desc:      "Busca y filtra elementos registrados",
          icon:      "manage_search",
          component: "ConsultaPorCodigo",
        },
        {
          key:       "inactivar",
          label:     "Inactivar códigos",
          desc:      "Inactiva elementos del detalle de la planilla",
          icon:      "block",
          component: "InactivarCodigos",
        },
        {
          key:       "observacion",
          label:     "Insertar observación",
          desc:      "Agrega una observación al detalle de la planilla",
          icon:      "edit_note",
          component: "InsertarObservacion",
        },
      ],
    };
  },

  methods: {
    toggle(key) {
      this.abierto = this.abierto === key ? null : key;
    },
  },
};
</script>

<style scoped>
.funcionalidades-panel {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 0;
}

/* ── Ítem ────────────────────────────────────────────────────── */
.acord-item {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,.05);
  transition: box-shadow .2s;
}
.acord-item.is-open {
  box-shadow: 0 4px 14px rgba(13,110,253,.1);
  border-color: #b6d0fe;
}

/* ── Header ──────────────────────────────────────────────────── */
.acord-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  border: none;
  background: #f8f9fa;
  cursor: pointer;
  text-align: left;
  transition: background .15s;
  gap: 10px;
}
.acord-header:hover   { background: #eef2ff; }
.acord-header.is-open { background: #e8f0fe; border-bottom: 1px solid #b6d0fe; }

.acord-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.acord-icon {
  font-size: 22px;
  color: #2563eb;
  flex-shrink: 0;
}
.acord-header.is-open .acord-icon { color: #1d4ed8; }

.acord-title {
  display: block;
  font-weight: 700;
  font-size: .88rem;
  color: #1a1d23;
  line-height: 1.2;
}
.acord-sub {
  display: block;
  font-size: .72rem;
  color: #6c757d;
  margin-top: 1px;
}

.chevron {
  font-size: 20px;
  color: #6c757d;
  flex-shrink: 0;
  transition: transform .2s;
}
.acord-header.is-open .chevron { color: #2563eb; }

/* ── Body ────────────────────────────────────────────────────── */
.acord-body {
  padding: 12px 14px;
  background: #fff;
}

/* Bloqueado */
.panel-bloqueado {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  color: #6c757d;
  font-size: .82rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px dashed #dee2e6;
}
</style>